import { render, staticRenderFns } from "./BookConsultation.vue?vue&type=template&id=272d5fef&scoped=true&"
import script from "./BookConsultation.vue?vue&type=script&lang=js&"
export * from "./BookConsultation.vue?vue&type=script&lang=js&"
import style0 from "./BookConsultation.vue?vue&type=style&index=0&id=272d5fef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d5fef",
  null
  
)

export default component.exports